export let cityList = {
  "Andhra Pradesh": [
    "Addanki",
    "Adivivaram",
    "Adoni",
    "Aganampudi",
    "Ajjaram",
    "Akividu",
    "Akkarampalle",
    "Akkayapalle",
    "Akkireddipalem",
    "Alampur",
    "Amalapuram",
    "Amudalavalasa",
    "Amur",
    "Anakapalle",
    "Anantapur",
    "Andole",
    "Atmakur",
    "Attili",
    "Avanigadda",
    "Badepalli",
    "Badvel",
    "Balapur",
    "Bandarulanka",
    "Banganapalle",
    "Bapatla",
    "Bapulapadu",
    "Belampalli",
    "Bestavaripeta",
    "Betamcherla",
    "Bhattiprolu",
    "Bhimavaram",
    "Bhimunipatnam",
    "Bobbili",
    "Bombuflat",
    "Bommuru",
    "Bugganipalle",
    "Challapalle",
    "Chandur",
    "Chatakonda",
    "Chemmumiahpet",
    "Chidiga",
    "Chilakaluripet",
    "Chimakurthy",
    "Chinagadila",
    "Chinagantyada",
    "Chinnachawk",
    "Chintalavalasa",
    "Chipurupalle",
    "Chirala",
    "Chittoor",
    "Chodavaram",
    "Choutuppal",
    "Chunchupalle",
    "Cuddapah",
    "Cumbum",
    "Darnakal",
    "Dasnapur",
    "Dauleshwaram",
    "Dharmavaram",
    "Dhone",
    "Dommara Nandyal",
    "Dowlaiswaram",
    "East Godavari Dist.",
    "Eddumailaram",
    "Edulapuram",
    "Ekambara kuppam",
    "Eluru",
    "Enikapadu",
    "Fakirtakya",
    "Farrukhnagar",
    "Gaddiannaram",
    "Gajapathinagaram",
    "Gajularega",
    "Gajuvaka",
    "Gannavaram",
    "Garacharma",
    "Garimellapadu",
    "Giddalur",
    "Godavarikhani",
    "Gopalapatnam",
    "Gopalur",
    "Gorrekunta",
    "Gudivada",
    "Gudur",
    "Guntakal",
    "Guntur",
    "Guti",
    "Hindupur",
    "Hukumpeta",
    "Ichchapuram",
    "Isnapur",
    "Jaggayyapeta",
    "Jallaram Kamanpur",
    "Jammalamadugu",
    "Jangampalli",
    "Jarjapupeta",
    "Kadiri",
    "Kaikalur",
    "Kakinada",
    "Kallur",
    "Kalyandurg",
    "Kamalapuram",
    "Kamareddi",
    "Kanapaka",
    "Kanigiri",
    "Kanithi",
    "Kankipadu",
    "Kantabamsuguda",
    "Kanuru",
    "Karnul",
    "Katheru",
    "Kavali",
    "Kazipet",
    "Khanapuram Haveli",
    "Kodar",
    "Kollapur",
    "Kondapalem",
    "Kondapalle",
    "Kondukur",
    "Kosgi",
    "Kothavalasa",
    "Kottapalli",
    "Kovur",
    "Kovurpalle",
    "Kovvur",
    "Krishna",
    "Kuppam",
    "Kurmannapalem",
    "Kurnool",
    "Lakshettipet",
    "Lalbahadur Nagar",
    "Machavaram",
    "Macherla",
    "Machilipatnam",
    "Madanapalle",
    "Madaram",
    "Madhuravada",
    "Madikonda",
    "Madugule",
    "Mahabubnagar",
    "Mahbubabad",
    "Malkajgiri",
    "Mamilapalle",
    "Mancheral",
    "Mandapeta",
    "Mandasa",
    "Mangalagiri",
    "Manthani",
    "Markapur",
    "Marturu",
    "Metpalli",
    "Mindi",
    "Mirpet",
    "Moragudi",
    "Mothugudam",
    "Nagari",
    "Nagireddipalle",
    "Nandigama",
    "Nandikotkur",
    "Nandyal",
    "Narasannapeta",
    "Narasapur",
    "Narasaraopet",
    "Narayanavanam",
    "Narsapur",
    "Narsingi",
    "Narsipatnam",
    "Naspur",
    "Nathayyapalem",
    "Nayudupeta",
    "Nelimaria",
    "Nellore",
    "Nidadavole",
    "Nuzvid",
    "Omerkhan daira",
    "Ongole",
    "Osmania University",
    "Pakala",
    "Palakole",
    "Palakurthi",
    "Palasa",
    "Palempalle",
    "Palkonda",
    "Palmaner",
    "Pamur",
    "Panjim",
    "Papampeta",
    "Parasamba",
    "Parvatipuram",
    "Patancheru",
    "Payakaraopet",
    "Pedagantyada",
    "Pedana",
    "Peddapuram",
    "Pendurthi",
    "Penugonda",
    "Penukonda",
    "Phirangipuram",
    "Pithapuram",
    "Ponnur",
    "Port Blair",
    "Pothinamallayyapalem",
    "Prakasam",
    "Prasadampadu",
    "Prasantinilayam",
    "Proddatur",
    "Pulivendla",
    "Punganuru",
    "Puttur",
    "Qutubullapur",
    "Rajahmundry",
    "Rajamahendri",
    "Rajampet",
    "Rajendranagar",
    "Rajoli",
    "Ramachandrapuram",
    "Ramanayyapeta",
    "Ramapuram",
    "Ramarajupalli",
    "Ramavarappadu",
    "Rameswaram",
    "Rampachodavaram",
    "Ravulapalam",
    "Rayachoti",
    "Rayadrug",
    "Razam",
    "Razole",
    "Renigunta",
    "Repalle",
    "Rishikonda",
    "Salur",
    "Samalkot",
    "Sattenapalle",
    "Seetharampuram",
    "Serilungampalle",
    "Shankarampet",
    "Shar",
    "Singarayakonda",
    "Sirpur",
    "Sirsilla",
    "Sompeta",
    "Sriharikota",
    "Srikakulam",
    "Srikalahasti",
    "Sriramnagar",
    "Sriramsagar",
    "Srisailam",
    "Srisailamgudem Devasthanam",
    "Sulurpeta",
    "Suriapet",
    "Suryaraopet",
    "Tadepalle",
    "Tadepalligudem",
    "Tadpatri",
    "Tallapalle",
    "Tanuku",
    "Tekkali",
    "Tenali",
    "Tigalapahad",
    "Tiruchanur",
    "Tirumala",
    "Tirupati",
    "Tirvuru",
    "Trimulgherry",
    "Tuni",
    "Turangi",
    "Ukkayapalli",
    "Ukkunagaram",
    "Uppal Kalan",
    "Upper Sileru",
    "Uravakonda",
    "Vadlapudi",
    "Vaparala",
    "Vemalwada",
    "Venkatagiri",
    "Venkatapuram",
    "Vepagunta",
    "Vetapalem",
    "Vijayapuri",
    "Vijayapuri South",
    "Vijayawada",
    "Vinukonda",
    "Visakhapatnam",
    "Vizianagaram",
    "Vuyyuru",
    "Wanparti",
    "West Godavari Dist.",
    "Yadagirigutta",
    "Yarada",
    "Yellamanchili",
    "Yemmiganur",
    "Yenamalakudru",
    "Yendada",
    "Yerraguntla"
  ],
  "Arunachal Pradesh": [
    "Anjaw",
    "Changlang",
    "East Siang",
    "Kurung Kumey",
    "Lohit",
    "Lower Dibang Valley",
    "Lower Subansiri",
    "Papum Pare",
    "Tawang",
    "Tirap",
    "Dibang Valley",
    "Upper Siang",
    "Upper Subansiri",
    "West Kameng ",
    "West Siang"
  ],
  "Assam": [
    "Baksa",
    "Barpeta",
    "Bongaigaon",
    "Cachar",
    "Chirang",
    "Darrang",
    "Dhemaji",
    "Dima Hasao",
    "Dhubri",
    "Dibrugarh",
    "Goalpara",
    "Golaghat",
    "Hailakandi",
    "Jorhat",
    "Kamrup",
    "Kamrup Metropolitan",
    "Karbi Anglong",
    "Karimganj",
    "Kokrajhar",
    "Lakhimpur",
    "Marigaon",
    "Nagaon",
    "Nalbari",
    "Sibsagar",
    "Sonitpur",
    "Tinsukia",
    "Udalguri"
  ],
  "Bihar": [
    "Araria",
    "Arwal",
    "Aurangabad",
    "Banka",
    "Begusarai",
    "Bhagalpur",
    "Bhojpur",
    "Buxar",
    "Darbhanga",
    "East Champaran",
    "Gaya",
    "Gopalganj",
    "Jamui",
    "Jehanabad",
    "Kaimur",
    "Katihar",
    "Khagaria",
    "Kishanganj",
    "Lakhisarai",
    "Madhepura",
    "Madhubani",
    "Munger",
    "Muzaffarpur",
    "Nalanda",
    "Nawada",
    "Patna",
    "Purnia",
    "Rohtas",
    "Saharsa",
    "Samastipur",
    "Saran",
    "Sheikhpura",
    "Sheohar",
    "Sitamarhi",
    "Siwan",
    "Supaul",
    "Vaishali",
    "West Champaran"
  ],
  "Chandigarh": [
    "Chandigarh"
  ],
  "Chhattisgarh": [
    "Bastar",
    "Bijapur",
    "Bilaspur",
    "Dantewada",
    "Dhamtari",
    "Durg",
    "Jashpur",
    "Janjgir-Champa",
    "Korba",
    "Koriya",
    "Kanker",
    "Kabirdham (Kawardha)",
    "Mahasamund",
    "Narayanpur",
    "Raigarh",
    "Rajnandgaon",
    "Raipur",
    "Surguja"
  ],
  "Dadra and Nagar Haveli": [
    "Dadra and Nagar Haveli"
  ],
  "Daman and Diu": [
    "Daman",
    "Diu"
  ],
  "Delhi": [
    "Central Delhi",
    "East Delhi",
    "New Delhi",
    "North Delhi",
    "North East Delhi",
    "North West Delhi",
    "South Delhi",
    "South West Delhi",
    "West Delhi"
  ],
  "Goa": [
    "Aldona",
    "Altinho",
    "Aquem",
    "Arpora",
    "Bambolim",
    "Bandora",
    "Bardez",
    "Benaulim",
    "Betora",
    "Bicholim",
    "Calapor",
    "Candolim",
    "Caranzalem",
    "Carapur",
    "Chicalim",
    "Chimbel",
    "Chinchinim",
    "Colvale",
    "Corlim",
    "Cortalim",
    "Cuncolim",
    "Curchorem",
    "Curti",
    "Davorlim",
    "Dona Paula",
    "Goa",
    "Guirim",
    "Jua",
    "Kalangat",
    "Kankon",
    "Kundaim",
    "Loutulim",
    "Madgaon",
    "Mapusa",
    "Margao",
    "Margaon",
    "Miramar",
    "Morjim",
    "Mormugao",
    "Navelim",
    "Pale",
    "Panaji",
    "Parcem",
    "Parra",
    "Penha de Franca",
    "Pernem",
    "Pilerne",
    "Pissurlem",
    "Ponda",
    "Porvorim",
    "Quepem",
    "Queula",
    "Raia",
    "Reis Magos",
    "Salcette",
    "Saligao",
    "Sancoale",
    "Sanguem",
    "Sanquelim",
    "Sanvordem",
    "Sao Jose-de-Areal",
    "Sattari",
    "Serula",
    "Sinquerim",
    "Siolim",
    "Taleigao",
    "Tivim",
    "Valpoi",
    "Varca",
    "Vasco",
    "Verna"
  ],
  "Gujarat": [
    "Ahmedabad",
    "Amreli district",
    "Anand",
    "Banaskantha",
    "Bharuch",
    "Bhavnagar",
    "Dahod",
    "The Dangs",
    "Gandhinagar",
    "Jamnagar",
    "Junagadh",
    "Kutch",
    "Kheda",
    "Mehsana",
    "Narmada",
    "Navsari",
    "Patan",
    "Panchmahal",
    "Porbandar",
    "Rajkot",
    "Sabarkantha",
    "Surendranagar",
    "Surat",
    "Vyara",
    "Vadodara",
    "Valsad"
  ],
  "Haryana": [
    "Ambala",
    "Bhiwani",
    "Faridabad",
    "Fatehabad",
    "Gurgaon",
    "Hissar",
    "Jhajjar",
    "Jind",
    "Karnal",
    "Kaithal",
    "Kurukshetra",
    "Mahendragarh",
    "Mewat",
    "Palwal",
    "Panchkula",
    "Panipat",
    "Rewari",
    "Rohtak",
    "Sirsa",
    "Sonipat",
    "Yamuna Nagar"
  ],
  "Himachal Pradesh": [
    "Bilaspur",
    "Chamba",
    "Hamirpur",
    "Kangra",
    "Kinnaur",
    "Kullu",
    "Lahaul and Spiti",
    "Mandi",
    "Shimla",
    "Sirmaur",
    "Solan",
    "Una"
  ],
  "Jammu and Kashmir": [
    "Anantnag",
    "Badgam",
    "Bandipora",
    "Baramulla",
    "Doda",
    "Ganderbal",
    "Jammu",
    "Kargil",
    "Kathua",
    "Kishtwar",
    "Kupwara",
    "Kulgam",
    "Leh",
    "Poonch",
    "Pulwama",
    "Rajauri",
    "Ramban",
    "Reasi",
    "Samba",
    "Shopian",
    "Srinagar",
    "Udhampur"
  ],
  "Jharkhand": [
    "Bokaro",
    "Chatra",
    "Deoghar",
    "Dhanbad",
    "Dumka",
    "East Singhbhum",
    "Garhwa",
    "Giridih",
    "Godda",
    "Gumla",
    "Hazaribag",
    "Jamtara",
    "Khunti",
    "Koderma",
    "Latehar",
    "Lohardaga",
    "Pakur",
    "Palamu",
    "Ramgarh",
    "Ranchi",
    "Sahibganj",
    "Seraikela Kharsawan",
    "Simdega",
    "West Singhbhum"
  ],
  "Karnataka": [
    "Adityanagar",
    "Adityapatna",
    "Afzalpur",
    "Ajjampur",
    "Aland",
    "Almatti Sitimani",
    "Alnavar",
    "Alur",
    "Ambikanagara",
    "Anekal",
    "Ankola",
    "Annigeri",
    "Arkalgud",
    "Arsikere",
    "Athni",
    "Aurad",
    "Badagavettu",
    "Badami",
    "Bagalkot",
    "Bagepalli",
    "Bailhongal",
    "Baindur",
    "Bajala",
    "Bajpe",
    "Banavar",
    "Bangarapet",
    "Bankapura",
    "Bannur",
    "Bantwal",
    "Basavakalyan",
    "Basavana Bagevadi",
    "Belagula",
    "Belakavadiq",
    "Belgaum",
    "Belgaum Cantonment",
    "Bellary",
    "Belluru",
    "Beltangadi",
    "Belur",
    "Belvata",
    "Bengaluru",
    "Bhadravati",
    "Bhalki",
    "Bhatkal",
    "Bhimarayanagudi",
    "Bhogadi",
    "Bidar",
    "Bijapur",
    "Bilgi",
    "Birur",
    "Bommanahalli",
    "Bommasandra",
    "Byadgi",
    "Byatarayanapura",
    "Chakranagar Colony",
    "Challakere",
    "Chamrajnagar",
    "Chamundi Betta",
    "Channagiri",
    "Channapatna",
    "Channarayapatna",
    "Chickballapur",
    "Chik Ballapur",
    "Chikkaballapur",
    "Chikmagalur",
    "Chiknayakanhalli",
    "Chikodi",
    "Chincholi",
    "Chintamani",
    "Chitaguppa",
    "Chitapur",
    "Chitradurga",
    "Coorg",
    "Dandeli",
    "Dargajogihalli",
    "Dasarahalli",
    "Davangere",
    "Devadurga",
    "Devagiri",
    "Devanhalli",
    "Dharwar",
    "Dhupdal",
    "Dod Ballapur",
    "Donimalai",
    "Gadag",
    "Gajendragarh",
    "Ganeshgudi",
    "Gangawati",
    "Gangoli",
    "Gauribidanur",
    "Gokak",
    "Gokak Falls",
    "Gonikoppal",
    "Gorur",
    "Gottikere",
    "Gubbi",
    "Gudibanda",
    "Gulbarga",
    "Guledgudda",
    "Gundlupet",
    "Gurmatkal",
    "Haliyal",
    "Hangal",
    "Harihar",
    "Harpanahalli",
    "Hassan",
    "Hatti",
    "Hatti Gold Mines",
    "Haveri",
    "Hebbagodi",
    "Hebbalu",
    "Hebri",
    "Heggadadevanakote",
    "Herohalli",
    "Hidkal",
    "Hindalgi",
    "Hirekerur",
    "Hiriyur",
    "Holalkere",
    "Hole Narsipur",
    "Homnabad",
    "Honavar",
    "Honnali",
    "Hosakote",
    "Hosanagara",
    "Hosangadi",
    "Hosdurga",
    "Hoskote",
    "Hospet",
    "Hubli",
    "Hukeri",
    "Hunasagi",
    "Hunasamaranahalli",
    "Hungund",
    "Hunsur",
    "Huvina Hadagalli",
    "Ilkal",
    "Indi",
    "Jagalur",
    "Jamkhandi",
    "Jevargi",
    "Jog Falls",
    "Kabini Colony",
    "Kadur",
    "Kalghatgi",
    "Kamalapuram",
    "Kampli",
    "Kanakapura",
    "Kangrali BK",
    "Kangrali KH",
    "Kannur",
    "Karkala",
    "Karwar",
    "Kemminja",
    "Kengeri",
    "Kerur",
    "Khanapur",
    "Kodigenahalli",
    "Kodiyal",
    "Kodlipet",
    "Kolar",
    "Kollegal",
    "Konanakunte",
    "Konanur",
    "Konnur",
    "Koppa",
    "Koppal",
    "Koratagere",
    "Kotekara",
    "Kothnur",
    "Kotturu",
    "Krishnapura",
    "Krishnarajanagar",
    "Krishnarajapura",
    "Krishnarajasagara",
    "Krishnarajpet",
    "Kudchi",
    "Kudligi",
    "Kudremukh",
    "Kumsi",
    "Kumta",
    "Kundapura",
    "Kundgol",
    "Kunigal",
    "Kurgunta",
    "Kushalnagar",
    "Kushtagi",
    "Kyathanahalli",
    "Lakshmeshwar",
    "Lingsugur",
    "Londa",
    "Maddur",
    "Madhugiri",
    "Madikeri",
    "Magadi",
    "Magod Falls",
    "Mahadeswara Hills",
    "Mahadevapura",
    "Mahalingpur",
    "Maisuru",
    "Maisuru Cantonment",
    "Malavalli",
    "Mallar",
    "Malpe",
    "Malur",
    "Manchenahalli",
    "Mandya",
    "Mangalore",
    "Mangaluru",
    "Manipal",
    "Manvi",
    "Maski",
    "Mastikatte Colony",
    "Mayakonda",
    "Melukote",
    "Molakalmuru",
    "Mudalgi",
    "Mudbidri",
    "Muddebihal",
    "Mudgal",
    "Mudhol",
    "Mudigere",
    "Mudushedde",
    "Mulbagal",
    "Mulgund",
    "Mulki",
    "Mulur",
    "Mundargi",
    "Mundgod",
    "Munirabad",
    "Munnur",
    "Murudeshwara",
    "Mysore",
    "Nagamangala",
    "Nanjangud",
    "Naragund",
    "Narasimharajapura",
    "Naravi",
    "Narayanpur",
    "Naregal",
    "Navalgund",
    "Nelmangala",
    "Nipani",
    "Nitte",
    "Nyamati",
    "Padu",
    "Pandavapura",
    "Pattanagere",
    "Pavagada",
    "Piriyapatna",
    "Ponnampet",
    "Puttur",
    "Rabkavi",
    "Raichur",
    "Ramanagaram",
    "Ramdurg",
    "Ranibennur",
    "Raybag",
    "Robertsonpet",
    "Ron",
    "Sadalgi",
    "Sagar",
    "Sakleshpur",
    "Saligram",
    "Sandur",
    "Sanivarsante",
    "Sankeshwar",
    "Sargur",
    "Sathyamangala",
    "Saundatti Yellamma",
    "Savanur",
    "Sedam",
    "Shahabad",
    "Shahabad A.C.C.",
    "Shahapur",
    "Shahpur",
    "Shaktinagar",
    "Shiggaon",
    "Shikarpur",
    "Shimoga",
    "Shirhatti",
    "Shorapur",
    "Shravanabelagola",
    "Shrirangapattana",
    "Siddapur",
    "Sidlaghatta",
    "Sindgi",
    "Sindhnur",
    "Sira",
    "Sirakoppa",
    "Sirsi",
    "Siruguppa",
    "Someshwar",
    "Somvarpet",
    "Sorab",
    "Sringeri",
    "Srinivaspur",
    "Sulya",
    "Suntikopa",
    "Talikota",
    "Tarikera",
    "Tekkalakota",
    "Terdal",
    "Thokur",
    "Thumbe",
    "Tiptur",
    "Tirthahalli",
    "Tirumakudal Narsipur",
    "Tonse",
    "Tumkur",
    "Turuvekere",
    "Udupi",
    "Ullal",
    "Uttarahalli",
    "Venkatapura",
    "Vijayapura",
    "Virarajendrapet",
    "Wadi",
    "Wadi A.C.C.",
    "Yadgir",
    "Yelahanka",
    "Yelandur",
    "Yelbarga",
    "Yellapur",
    "Yenagudde"
  ],
  "Kerala": [
    "Alappuzha",
    "Ernakulam",
    "Idukki",
    "Kannur",
    "Kasaragod",
    "Kollam",
    "Kottayam",
    "Kozhikode",
    "Malappuram",
    "Palakkad",
    "Pathanamthitta",
    "Thrissur",
    "Thiruvananthapuram",
    "Wayanad"
  ],
  "Ladakh": [
    "Kargil",
    "Leh"
  ],
  "Lakshadweep": [
    "Agethi",
    "Amini",
    "Androth Island",
    "Kavaratti",
    "Minicoy"
  ],
  "Madhya Pradesh": [
    "Alirajpur",
    "Anuppur",
    "Ashok Nagar",
    "Balaghat",
    "Barwani",
    "Betul",
    "Bhind",
    "Bhopal",
    "Burhanpur",
    "Chhatarpur",
    "Chhindwara",
    "Damoh",
    "Datia",
    "Dewas",
    "Dhar",
    "Dindori",
    "Guna",
    "Gwalior",
    "Harda",
    "Hoshangabad",
    "Indore",
    "Jabalpur",
    "Jhabua",
    "Katni",
    "Khandwa (East Nimar)",
    "Khargone (West Nimar)",
    "Mandla",
    "Mandsaur",
    "Morena",
    "Narsinghpur",
    "Neemuch",
    "Panna",
    "Rewa",
    "Rajgarh",
    "Ratlam",
    "Raisen",
    "Sagar",
    "Satna",
    "Sehore",
    "Seoni",
    "Shahdol",
    "Shajapur",
    "Sheopur",
    "Shivpuri",
    "Sidhi",
    "Singrauli",
    "Tikamgarh",
    "Ujjain",
    "Umaria",
    "Vidisha"
  ],
  "Maharashtra": [
    "Ahmednagar",
    "Akola",
    "Amravati",
    "Aurangabad",
    "Bhandara",
    "Beed",
    "Buldhana",
    "Chandrapur",
    "Dhule",
    "Gadchiroli",
    "Gondia",
    "Hingoli",
    "Jalgaon",
    "Jalna",
    "Kolhapur",
    "Latur",
    "Mumbai City",
    "Mumbai suburban",
    "Nandurbar",
    "Nanded",
    "Nagpur",
    "Nashik",
    "Osmanabad",
    "Parbhani",
    "Pune",
    "Raigad",
    "Ratnagiri",
    "Sindhudurg",
    "Sangli",
    "Solapur",
    "Satara",
    "Thane",
    "Wardha",
    "Washim",
    "Yavatmal"
  ],
  "Manipur": [
    "Bishnupur",
    "Churachandpur",
    "Chandel",
    "Imphal East",
    "Senapati",
    "Tamenglong",
    "Thoubal",
    "Ukhrul",
    "Imphal West"
  ],
  "Meghalaya": [
    "East Garo Hills",
    "East Khasi Hills",
    "Jaintia Hills",
    "Ri Bhoi",
    "South Garo Hills",
    "West Garo Hills",
    "West Khasi Hills"
  ],
  "Mizoram": [
    "Aizawl",
    "Champhai",
    "Kolasib",
    "Lawngtlai",
    "Lunglei",
    "Mamit",
    "Saiha",
    "Serchhip"
  ],
  "Nagaland": [
    "Dimapur",
    "Kohima",
    "Mokokchung",
    "Mon",
    "Phek",
    "Tuensang",
    "Wokha",
    "Zunheboto"
  ],
  "Odisha": [
    "Angul",
    "Boudh (Bauda)",
    "Bhadrak",
    "Balangir",
    "Bargarh (Baragarh)",
    "Balasore",
    "Cuttack",
    "Debagarh (Deogarh)",
    "Dhenkanal",
    "Ganjam",
    "Gajapati",
    "Jharsuguda",
    "Jajpur",
    "Jagatsinghpur",
    "Khordha",
    "Kendujhar (Keonjhar)",
    "Kalahandi",
    "Kandhamal",
    "Koraput",
    "Kendrapara",
    "Malkangiri",
    "Mayurbhanj",
    "Nabarangpur",
    "Nuapada",
    "Nayagarh",
    "Puri",
    "Rayagada",
    "Sambalpur",
    "Subarnapur (Sonepur)",
    "Sundergarh"
  ],
  "Puducherry": [
    "Karaikal",
    "Mahe",
    "Pondicherry",
    "Yanam"
  ],
  "Punjab": [
    "Amritsar",
    "Barnala",
    "Bathinda",
    "Firozpur",
    "Faridkot",
    "Fatehgarh Sahib",
    "Fazilka",
    "Gurdaspur",
    "Hoshiarpur",
    "Jalandhar",
    "Kapurthala",
    "Ludhiana",
    "Mansa",
    "Moga",
    "Sri Muktsar Sahib",
    "Pathankot",
    "Patiala",
    "Rupnagar",
    "Ajitgarh (Mohali)",
    "Sangrur",
    "Nawanshahr",
    "Tarn Taran"
  ],
  "Rajasthan": [
    "Ajmer",
    "Alwar",
    "Bikaner",
    "Barmer",
    "Banswara",
    "Bharatpur",
    "Baran",
    "Bundi",
    "Bhilwara",
    "Churu",
    "Chittorgarh",
    "Dausa",
    "Dholpur",
    "Dungapur",
    "Ganganagar",
    "Hanumangarh",
    "Jhunjhunu",
    "Jalore",
    "Jodhpur",
    "Jaipur",
    "Jaisalmer",
    "Jhalawar",
    "Karauli",
    "Kota",
    "Nagaur",
    "Pali",
    "Pratapgarh",
    "Rajsamand",
    "Sikar",
    "Sawai Madhopur",
    "Sirohi",
    "Tonk",
    "Udaipur"
  ],
  "Sikkim": [
    "East Sikkim",
    "North Sikkim",
    "South Sikkim",
    "West Sikkim"
  ],
  "Tamil Nadu": [
    "Ariyalur",
    "Chennai",
    "Coimbatore",
    "Cuddalore",
    "Dharmapuri",
    "Dindigul",
    "Erode",
    "Kanchipuram",
    "Kanyakumari",
    "Karur",
    "Madurai",
    "Nagapattinam",
    "Nilgiris",
    "Namakkal",
    "Perambalur",
    "Pudukkottai",
    "Ramanathapuram",
    "Salem",
    "Sivaganga",
    "Tirupur",
    "Tiruchirappalli",
    "Theni",
    "Tirunelveli",
    "Thanjavur",
    "Thoothukudi",
    "Tiruvallur",
    "Tiruvarur",
    "Tiruvannamalai",
    "Vellore",
    "Viluppuram",
    "Virudhunagar"
  ],
  "Telangana": [
    "Achampet",
    "Adilabad",
    "Armoor",
    "Asifabad",
    "Badepally",
    "Banswada",
    "Bellampalli",
    "Bhadrachalam",
    "Bhainsa",
    "Bhongir",
    "Bhupalpally",
    "Bodhan",
    "Bollaram",
    "Devarkonda",
    "Farooqnagar",
    "Gadwal",
    "Gajwel",
    "Ghatkesar",
    "Hyderabad",
    "Jagtial",
    "Jangaon",
    "Kagaznagar",
    "Kalwakurthy",
    "Kamareddy",
    "Karimnagar",
    "Khammam",
    "Kodada",
    "Koratla",
    "Kottagudem",
    "Kyathampalle",
    "Madhira",
    "Mahabubabad",
    "Mahbubnagar",
    "Mancherial",
    "Mandamarri",
    "Manuguru",
    "Medak",
    "Medchal",
    "Miryalaguda",
    "Nagar Karnul",
    "Nakrekal",
    "Nalgonda",
    "Narayanpet",
    "Narsampet",
    "Nirmal",
    "Nizamabad",
    "Palwancha",
    "Peddapalli",
    "Ramagundam",
    "Ranga Reddy district",
    "Sadasivpet",
    "Sangareddy",
    "Sarapaka",
    "Sathupalle",
    "Secunderabad",
    "Siddipet",
    "Singapur",
    "Sircilla",
    "Suryapet",
    "Tandur",
    "Vemulawada",
    "Vikarabad",
    "Wanaparthy",
    "Warangal",
    "Yellandu",
    "Zahirabad"
  ],
  "Tripura": [
    "Dhalai",
    "North Tripura",
    "South Tripura",
    "Khowai",
    "West Tripura"
  ],
  "Uttar Pradesh": [
    "Agra",
    "Allahabad",
    "Aligarh",
    "Ambedkar Nagar",
    "Auraiya",
    "Azamgarh",
    "Barabanki",
    "Budaun",
    "Bagpat",
    "Bahraich",
    "Bijnor",
    "Ballia",
    "Banda",
    "Balrampur",
    "Bareilly",
    "Basti",
    "Bulandshahr",
    "Chandauli",
    "Chhatrapati Shahuji Maharaj Nagar",
    "Chitrakoot",
    "Deoria",
    "Etah",
    "Kanshi Ram Nagar",
    "Etawah",
    "Firozabad",
    "Farrukhabad",
    "Fatehpur",
    "Faizabad",
    "Gautam Buddh Nagar",
    "Gonda",
    "Ghazipur",
    "Gorakhpur",
    "Ghaziabad",
    "Hamirpur",
    "Hardoi",
    "Mahamaya Nagar",
    "Jhansi",
    "Jalaun",
    "Jyotiba Phule Nagar",
    "Jaunpur district",
    "Ramabai Nagar (Kanpur Dehat)",
    "Kannauj",
    "Kanpur",
    "Kaushambi",
    "Kushinagar",
    "Lalitpur",
    "Lakhimpur Kheri",
    "Lucknow",
    "Mau",
    "Meerut",
    "Maharajganj",
    "Mahoba",
    "Mirzapur",
    "Moradabad",
    "Mainpuri",
    "Mathura",
    "Muzaffarnagar",
    "Panchsheel Nagar district (Hapur)",
    "Pilibhit",
    "Shamli",
    "Pratapgarh",
    "Rampur",
    "Raebareli",
    "Saharanpur",
    "Sitapur",
    "Shahjahanpur",
    "Sant Kabir Nagar",
    "Siddharthnagar",
    "Sonbhadra",
    "Sant Ravidas Nagar",
    "Sultanpur",
    "Shravasti",
    "Unnao",
    "Varanasi"
  ],
  "Uttarakhand": [
    "Almora",
    "Bageshwar",
    "Chamoli",
    "Champawat",
    "Dehradun",
    "Haridwar",
    "Nainital",
    "Pauri Garhwal",
    "Pithoragarh",
    "Rudraprayag",
    "Tehri Garhwal",
    "Udham Singh Nagar",
    "Uttarkashi"
  ],
  "West Bengal": [
    "Birbhum",
    "Bankura",
    "Bardhaman",
    "Darjeeling",
    "Dakshin Dinajpur",
    "Hooghly",
    "Howrah",
    "Jalpaiguri",
    "Cooch Behar",
    "Kolkata",
    "Maldah",
    "Paschim Medinipur",
    "Purba Medinipur",
    "Murshidabad",
    "Nadia",
    "North 24 Parganas",
    "South 24 Parganas",
    "Purulia",
    "Uttar Dinajpur"
  ]
}
